
import { defineComponent, computed } from "vue";
import store from "../store";

export default defineComponent({
    data() {
        const score = computed(() => store.getters.score);
        return { size: "12", score };
    },
    methods: {
        async generate(e?: Event) {
            await store.dispatch("generateCards", {
                size: parseInt(this.size, 10)
            });
        }
    },
    name: "game-menu",
    mounted() {
        this.generate();
    }
});
